import React, { useRef } from 'react';
import antes1 from '../assets/antes1.jpg';
import antes2 from '../assets/antes2.jpg';
import antes3 from '../assets/antes3.jpg';
import depois1 from '../assets/depois1.jpg';
import depois2 from '../assets/depois2.jpg';
import depois3 from '../assets/depois3.jpg';

const cases = [
  { label: 'CASO 01', before: antes1, after: depois1 },
  { label: 'CASO 02', before: antes2, after: depois2 },
  { label: 'CASO 03', before: antes3, after: depois3 },
];

const BeforeAfterCard = ({ item }) => {
  const ref = useRef(null);
  const { label, before, after } = item;

  const move = clientX => {
    const el = ref.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    const pct = Math.max(0, Math.min(100, ((clientX - rect.left) / rect.width) * 100));
    el.style.setProperty('--compare-x', `${pct}%`);
  };

  const startPointer = e => {
    move(e.clientX);
    e.currentTarget.setPointerCapture?.(e.pointerId);
  };

  return (
    <div
      ref={ref}
      className="compare"
      style={{ '--compare-x': '50%' }}
      onPointerDown={startPointer}
      onPointerMove={e => e.buttons && move(e.clientX)}
      role="img"
      aria-label={`Antes e depois - ${label}`}
    >
      <div className="compare-side before">
        {before ? (
          <img src={before} alt={`Antes - ${label}`} />
        ) : (
          <div className="ph">ANTES - {label}</div>
        )}
      </div>
      <div className="compare-side after">
        {after ? (
          <img src={after} alt={`Depois - ${label}`} />
        ) : (
          <div className="ph">DEPOIS</div>
        )}
      </div>
      <div className="compare-label lbl-before">Antes</div>
      <div className="compare-label lbl-after">Depois</div>
      <div className="compare-handle"></div>
    </div>
  );
};

const BeforeAfter = () => (
  <>
    <div className="divider" id="casos">
      <span><span className="dot"></span> 06 / Casos</span>
      <span>Antes & Depois</span>
    </div>

    <section className="ad">
      <div className="ad-head">
        <h2 className="display">Trabalhos <em>reais</em>, em mãos reais.</h2>
        <p className="aside">
          Uma amostra de casos feitos em nosso consultório. Arraste o divisor para comparar.
          Estes são placeholders - a galeria final usará fotos autorizadas de pacientes.
        </p>
      </div>

      <div className="ad-grid">
        {cases.map(item => <BeforeAfterCard key={item.label} item={item} />)}
      </div>
    </section>
  </>
);

export default BeforeAfter;
